
import React from 'react';
import { Link } from 'react-router-dom';

const SecurityChallenges: React.FC = () => {
  return (
    <>
      <div id="security-challenges"></div>
      <p className="mb-6 text-gray-700 leading-relaxed">
        CPA firms face unique security challenges that stem from the nature of their work and the sensitive information they handle:
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Regulatory Compliance Requirements</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Firms must comply with various regulations including IRS regulations (IRC Section 7216), AICPA Code of Professional Conduct, and often state-specific privacy laws. For firms with international clients, considerations may extend to GDPR and other global frameworks. Our <Link to="/services/cybersecurity" className="text-itmgmt-bright-blue hover:underline">cybersecurity services</Link> can help ensure your firm meets these regulatory requirements.
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Client Data Sensitivity</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Financial documents contain highly sensitive information: Social Security numbers, bank account details, tax IDs, and comprehensive financial histories. Unauthorized access to this information can lead to identity theft, financial fraud, and significant liability for the firm.
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Evolving Cybersecurity Threats</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        Accounting firms are prime targets for cybercriminals. According to recent industry reports, financial services experience 300% more cybersecurity incidents than other industries, with accounting firms being particularly vulnerable during tax season when systems are under pressure and containing freshly updated financial information. Implementing a <Link to="/blog/zero-trust-security-small-businesses" className="text-itmgmt-bright-blue hover:underline">zero-trust security</Link> approach can significantly reduce these risks.
      </p>
      
      <h3 className="text-xl font-semibold mb-3 text-itmgmt-medium-blue">Remote Work Challenges</h3>
      <p className="mb-6 text-gray-700 leading-relaxed">
        The shift toward remote and hybrid work environments has introduced additional security concerns, as documents now traverse home networks and personal devices that may lack enterprise-grade security measures. Our <Link to="/services/managed-it-services" className="text-itmgmt-bright-blue hover:underline">managed IT services</Link> include solutions specifically designed for secure remote work environments.
      </p>
    </>
  );
};

export default SecurityChallenges;
